import { useEffect } from 'react';

import { useWizard } from 'components/Wizard/components/context';

function PrevStep() {
  const { goToPrevStep } = useWizard();
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => goToPrevStep(), []);

  return null;
}

PrevStep.displayName = 'PrevStep';

export { PrevStep };
